__turbopack_context__.v({
  "className": "great_vibes_758e9315-module__lEWywG__className",
});
